// extracted by mini-css-extract-plugin
export default {"list":"R48l1J","item":"fGQaI3","link":"afhuBi","message":"ZlkxRP","alignLeft":"Skzhu9","alignCenter":"bcGSQK","alignRight":"pL1HZm","text":"SwUB5x"};